var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.5,
    fill: "#F2F6F7",
    stroke: "#162936"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99438 5.33398V14.7651",
    stroke: "#818385",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 11.8831C7.1875 12.8995 8.02958 13.7169 9.06251 13.7169H11.1733C12.0715 13.7169 12.8013 13.0043 12.8013 12.1136C12.8013 11.16 12.3522 10.8142 11.6897 10.5941L8.31025 9.49384C7.64783 9.27378 7.19874 8.93845 7.19874 7.97438C7.19874 7.09415 7.92851 6.37109 8.82671 6.37109H10.9375C11.9704 6.37109 12.8125 7.18846 12.8125 8.20492",
    stroke: "#818385",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.9d8f91b4a91befe6b149b08bc3f1d5f5.svg";
export { ForwardRef as ReactComponent };